import { createInstance } from './axios.api'

import {
  AddressSearchResponse,
  ApartmentSearchResponse,
  AreaInfoResponse
} from '@/types/area-response.types'

import { AreaStatus, AreaType } from '@/constants/operator'

const isAreaInfoNoticeOfInterestUpsell = (areaInfo: AreaInfoResponse): boolean => {
  return areaInfo.AreaStatusName === AreaStatus.Status679 && areaInfo.AreaTypeName === AreaType.Upsell
}

const isAreaInfoNoticeOfInterestFwa = (areaInfo: AreaInfoResponse): boolean => {
  return areaInfo.AreaStatusName === AreaStatus.FwaInterest ||
  areaInfo.AreaStatusName === AreaStatus.FwaInterestAfterBuilding ||
  areaInfo.AreaStatusName === AreaStatus.FwaLowbandInterest ||
  areaInfo.AreaStatusName === AreaStatus.FwaSiteDevelopmentInterest ||
  areaInfo.AreaStatusName === AreaStatus.FwaSiteDevelopmentInterestAfterBuilding
}

const isAreaInfoNoticeOfInterestRural = (areaInfo: AreaInfoResponse): boolean => {
  return areaInfo.AreaStatusName === AreaStatus.RuralInterest || areaInfo.AreaStatusName === AreaStatus.RuralInterestAfterBuilding || areaInfo.AreaStatusName === AreaStatus.RuralInterestAfterSalesQuote || areaInfo.AreaStatusName === AreaStatus.RuralInterestAfterSalesSuc
}

export const isAreaInfoNoticeOfInterest = (areaInfo: AreaInfoResponse): boolean => {
  return areaInfo !== null && (isAreaInfoNoticeOfInterestUpsell(areaInfo) || isAreaInfoNoticeOfInterestFwa(areaInfo) || isAreaInfoNoticeOfInterestRural(areaInfo))
}

const fetchAddresses = async (searchString: string): Promise<AddressSearchResponse> => {
  const axios = createInstance(process.env.VUE_APP_ADDRESS_SEARCH_API_URL)

  const { data } = await axios.get('/search', { params: { searchString, pageSize: 10, page: 0 } })
  return data
}

const fetchApartments = async (fullAddress: string, city: string): Promise<ApartmentSearchResponse> => {
  const axios = createInstance(process.env.VUE_APP_ADDRESS_SEARCH_API_URL)

  const { data } = await axios.get( '/apartment-numbers', { params: { fullAddress, city, pageSize: 100, page: 0 } })
  return data
}

export default {
  fetchAddresses,
  fetchApartments
}
